import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, Download, Github, Linkedin, Mail, MapPin } from 'lucide-react';
import { profileData } from '../data/mock';

const Hero = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section className="min-h-screen flex items-center justify-center px-4 sm:px-6 lg:px-8 pt-20 pb-16">
      <div className="max-w-6xl w-full">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-6 animate-fade-in">
            <div className="space-y-3">
              <p className="text-[#00AFF0] font-medium text-sm tracking-wide uppercase">
                Software Engineer {profileData.pronouns}
              </p>
              <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold text-gray-900 leading-tight">
                {profileData.name}
              </h1>
              <p className="text-xl text-gray-600 flex items-center gap-2">
                <MapPin className="w-5 h-5 text-[#00AFF0]" />
                {profileData.location}
              </p>
            </div>
            
            <p className="text-lg text-gray-700 leading-relaxed max-w-xl">
              {profileData.title} with 6+ years of experience specializing in Java/J2EE, Spring Boot, and Angular. 
              Passionate about building scalable solutions and driving innovation.
            </p>
            
            {/* CTA Buttons */}
            <div className="flex flex-wrap gap-4 pt-4">
              <Button 
                onClick={() => scrollToSection('contact')}
                className="bg-[#00AFF0] hover:bg-[#0099D6] text-white px-8 py-6 text-lg rounded-lg transition-all duration-300 hover:shadow-lg hover:shadow-[#00AFF0]/30 group"
              >
                Get In Touch
                <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
              </Button>
              <Button 
                variant="outline"
                className="border-2 border-gray-900 text-gray-900 hover:bg-gray-900 hover:text-white px-8 py-6 text-lg rounded-lg transition-all duration-300 group"
              >
                Download Resume
                <Download className="ml-2 w-5 h-5 group-hover:translate-y-0.5 transition-transform" />
              </Button>
            </div>
            
            {/* Social Links */}
            <div className="flex gap-4 pt-4">
              <a 
                href={`https://${profileData.github}`}
                target="_blank"
                rel="noopener noreferrer"
                className="w-12 h-12 rounded-full border-2 border-gray-300 flex items-center justify-center hover:border-[#00AFF0] hover:bg-[#00AFF0]/5 transition-all duration-300"
              >
                <Github className="w-5 h-5 text-gray-700" />
              </a>
              <a 
                href={`https://${profileData.linkedin}`}
                target="_blank"
                rel="noopener noreferrer"
                className="w-12 h-12 rounded-full border-2 border-gray-300 flex items-center justify-center hover:border-[#00AFF0] hover:bg-[#00AFF0]/5 transition-all duration-300"
              >
                <Linkedin className="w-5 h-5 text-gray-700" />
              </a>
              <a 
                href={`mailto:${profileData.email}`}
                className="w-12 h-12 rounded-full border-2 border-gray-300 flex items-center justify-center hover:border-[#00AFF0] hover:bg-[#00AFF0]/5 transition-all duration-300"
              >
                <Mail className="w-5 h-5 text-gray-700" />
              </a>
            </div>
          </div>
          
          {/* Right Content - Profile Image/Illustration */}
          <div className="relative">
            <div className="relative w-full aspect-square max-w-md mx-auto">
              {/* Decorative circles */}
              <div className="absolute inset-0 bg-gradient-to-br from-[#00AFF0]/10 to-[#0099D6]/10 rounded-full blur-3xl animate-pulse"></div>
              <div className="absolute top-10 right-10 w-32 h-32 bg-[#00AFF0]/20 rounded-full blur-2xl"></div>
              <div className="absolute bottom-10 left-10 w-40 h-40 bg-[#0099D6]/20 rounded-full blur-2xl"></div>
              
              {/* Profile container */}
              <div className="relative w-full h-full rounded-2xl bg-gradient-to-br from-gray-50 to-gray-100 border-4 border-[#00AFF0]/20 overflow-hidden shadow-2xl">
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="text-center space-y-4 p-8">
                    <div className="w-32 h-32 mx-auto rounded-full bg-[#00AFF0]/10 border-4 border-[#00AFF0] flex items-center justify-center text-5xl font-bold text-[#00AFF0]">
                      AH
                    </div>
                    <div className="space-y-2">
                      <p className="text-2xl font-bold text-gray-900">{profileData.name}</p>
                      <p className="text-gray-600 font-medium">{profileData.title}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;